import React from 'react';
import BaseComponent from 'apps/new-web/views/component';
import createLayout from 'apps/new-web/views/pages/create-layout';
import reducers from './reducers';
import PreLoginNavigation from 'apps/new-web/views/components/header';
import { connect } from 'react-redux';
import I18n from 'apps/new-web/views/components/i18n';
import ActivateConsole from 'apps/new-web/views/onboarding/activate/components/activate-console';


export class PureActivateMachinePage extends BaseComponent {
  constructor(props) {
    super(props);
  }

  static getAdditionalHeadTags() {
    return `<meta name="description" content="${ I18n.translate('Activate your machine.') }" />`;
  }

  render() {
    return (
      <div className="activate-console-page-container">
        <PreLoginNavigation />
        <main id="main-content" className="main-content-wrapper" />
        <ActivateConsole showHeader={ false } showButton={ false } />
      </div>
    );
  }
}

const ActivateMachinePage = connect(
  (state) => {
    return {
      ...state
    };
  }
)(PureActivateMachinePage);

export default createLayout(ActivateMachinePage, reducers);
